import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Modal, Card, CardContent, CardActions, Typography, Button } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { PageLoader } from 'components'


const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 500,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%',
  },
  body: {
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(-1),
  },
  actions: {
    // marginBottom: theme.spacing(1),
    justifyContent: 'center',
  },
  closeIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    "&:hover": {
      cursor: 'pointer',
      opacity: '80%',
    }
  },
  animatedIcon: {
    margin: theme.spacing(2, 0, 0, 0)
  },  
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(244, 246, 248, 0.8)',
    zIndex: 9999,
  }
}))

const StyledModal = ({
  className,
  open,
  title,
  children,
  onCancel,
  onConfirm,
  onConfirmLabel,
  options = [],
  animatedIcon,
  flag,
  ...rest
}) => {

  const classes = useStyles()
  const [lock, setLock] = useState(false)

  const noButtons = options.includes('noButtons')

  useEffect(() => {   
    flag && flag === 'processed' && setLock(false)
    flag && flag === 'processed' && onCancel()
  // eslint-disable-next-line
  }, [flag])

  const onContinue = () => {
    flag && setLock(true)
    onConfirm()
  }

  const onClose = () => lock ? null : onCancel()

  return (
    <Modal open={open ? true : false} onClose={onClose}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CloseIcon className={classes.closeIcon} onClick={onClose} />
        <CardContent>

          {title && (
            <Typography variant="h4" align="center">
              {title}
            </Typography>
          )}

          <Typography className={classes.body} variant="body1" align="center">
            {children}
          </Typography>

          {animatedIcon && (
            <div className={classes.animatedIcon}>
              {animatedIcon}
            </div>
          )}
          
          {lock && (
            <div className={classes.loader}>
              <PageLoader />
            </div>
          )}
        </CardContent>

        {!noButtons && (
          <CardActions className={classes.actions}>
            <Button
              disabled={lock}
              data-cy={`delete-btn`}
              color="primary"
              variant="contained"
              onClick={onContinue}>
              {onConfirmLabel ? onConfirmLabel : 'Confirm'}
            </Button>
            <Button
              disabled={lock}
              data-cy={`cancel-btn`}
              variant="contained"
              onClick={onCancel}>
              Cancel
            </Button>
          </CardActions>
        )}
      </Card>
    </Modal>
  )
}

StyledModal.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  onConfirmLabel: PropTypes.string,
  options: PropTypes.array,
  flag: PropTypes.string,
}

export default StyledModal
